import type {
    CashFlowData,
    CashFlowSummary,
    CashFlowTransaction,
    Category,
    ChartOfAccount,
    DashboardSummary,
    ExpenseByCategory,
    FAQ,
    IncomeBySource,
    PaymentMethod,
    Plan,
    User,
} from '../types';

export const mockPlans: Plan[] = [
    {
        id: 'free',
        name: 'Gratuito',
        description: 'Perfeito para começar a organizar suas finanças',
        price: 0,
        interval: 'monthly',
        features: ['graficos', 'settings'],
        isActive: true,
        maxAccounts: 2,
        maxTransactionsPerMonth: 50,
        createdAt: '2024-01-01T00:00:00',
        updatedAt: '2024-01-01T00:00:00',
    },
    {
        id: 'basic',
        name: 'Básico',
        description: 'Para quem quer mais controle financeiro',
        price: 19.90,
        interval: 'monthly',
        features: ['graficos', 'cashflow', 'settings', 'export_pdf'],
        isActive: true,
        maxAccounts: 5,
        maxTransactionsPerMonth: 200,
        createdAt: '2024-01-01T00:00:00',
        updatedAt: '2024-01-01T00:00:00',
    },
    {
        id: 'pro',
        name: 'Profissional',
        description: 'Recursos avançados para gestão completa',
        price: 49.90,
        interval: 'monthly',
        features: [
            'graficos', 'cashflow', 'reports',
            'settings',
            'export_pdf', 'export_excel', 'custom_categories'
        ],
        isActive: true,
        maxAccounts: 15,
        maxTransactionsPerMonth: 1000,
        createdAt: '2024-01-01T00:00:00',
        updatedAt: '2024-01-01T00:00:00',
    },
    {
        id: 'enterprise',
        name: 'Empresarial',
        description: 'Solução completa para empresas e profissionais',
        price: 99.90,
        interval: 'monthly',
        features: [
            'graficos', 'cashflow', 'reports',
            'settings',
            'export_pdf', 'export_excel', 'custom_categories',
            'api_access', 'priority_support'
        ],
        isActive: true,
        maxAccounts: -1,
        maxTransactionsPerMonth: -1,
        createdAt: '2024-01-01T00:00:00',
        updatedAt: '2024-01-01T00:00:00',
    },
];

export const mockUser: User = {
    id: '1',
    name: 'Maria Silva',
    email: 'maria@email.com',
    avatar: undefined,
    role: 'OPERADOR',
    planId: 'pro',
    planExpiresAt: '2026-06-15T10:00:00',
    status: 'active',
    createdAt: '2024-06-15T10:00:00',
};

export const mockAdminUser: User = {
    id: 'admin-1',
    name: 'Administrador',
    email: 'admin@financeirodiario.com',
    avatar: undefined,
    role: 'ADMIN',
    planId: 'enterprise',
    planExpiresAt: '2027-01-01T00:00:00',
    status: 'active',
    createdAt: '2024-01-01T00:00:00',
};

export const mockUsers: User[] = [
    mockAdminUser,
    mockUser,
    {
        id: '2',
        name: 'João Santos',
        email: 'joao@email.com',
        avatar: undefined,
        role: 'OPERADOR',
        planId: 'basic',
        planExpiresAt: '2026-03-20T14:30:00',
        status: 'active',
        createdAt: '2024-08-20T14:30:00',
    },
    {
        id: '3',
        name: 'Ana Costa',
        email: 'ana@email.com',
        avatar: undefined,
        role: 'OPERADOR',
        planId: 'free',
        status: 'active',
        createdAt: '2024-09-10T09:15:00',
    },
    {
        id: '4',
        name: 'Carlos Oliveira',
        email: 'carlos@email.com',
        avatar: undefined,
        role: 'OPERADOR',
        planId: 'enterprise',
        planExpiresAt: '2026-07-05T16:45:00',
        status: 'inactive',
        createdAt: '2024-07-05T16:45:00',
    },
    {
        id: '5',
        name: 'Fernanda Lima',
        email: 'fernanda@email.com',
        avatar: undefined,
        role: 'OPERADOR',
        planId: 'pro',
        planExpiresAt: '2026-02-01T00:00:00',
        status: 'active',
        createdAt: '2025-02-01T00:00:00',
    },
    {
        id: '6',
        name: 'Ricardo Mendes',
        email: 'ricardo@email.com',
        avatar: undefined,
        role: 'OPERADOR',
        planId: 'basic',
        planExpiresAt: '2025-12-15T00:00:00',
        status: 'suspended',
        createdAt: '2024-12-15T00:00:00',
    },
];

export const mockDashboardSummary: DashboardSummary = {
    totalIncome: 12500.0,
    totalExpenses: 8320.0,
    resultado: 4180.0,
};



export const mockCashFlowData: CashFlowData[] = [
    { month: 'Jul', income: 10500, expense: 6200 },
    { month: 'Ago', income: 11000, expense: 7800 },
    { month: 'Set', income: 10800, expense: 8100 },
    { month: 'Out', income: 11500, expense: 7500 },
    { month: 'Nov', income: 12000, expense: 8800 },
    { month: 'Dez', income: 12500, expense: 8320 },
];



export const mockCategories: Category[] = [
    { id: '1', name: 'Alimentação', type: 'expense', icon: 'food', color: '#F59E0B' },
    { id: '2', name: 'Transporte', type: 'expense', icon: 'car', color: '#059669' },
    { id: '3', name: 'Lazer', type: 'expense', icon: 'entertainment', color: '#0d9488' },
    { id: '4', name: 'Contas', type: 'expense', icon: 'bill', color: '#EF4444' },
    { id: '5', name: 'Saúde', type: 'expense', icon: 'heart', color: '#EC4899' },
    { id: '6', name: 'Educação', type: 'expense', icon: 'book', color: '#14B8A6' },
    { id: '7', name: 'Moradia', type: 'expense', icon: 'home', color: '#047857' },
    { id: '8', name: 'Vestuário', type: 'expense', icon: 'shirt', color: '#F97316' },
    { id: '9', name: 'Salário', type: 'income', icon: 'briefcase', color: '#22C55E' },
    { id: '10', name: 'Freelance', type: 'income', icon: 'monitor', color: '#059669' },
    { id: '11', name: 'Investimentos', type: 'income', icon: 'trending-up', color: '#0d9488' },
    { id: '12', name: 'Outros', type: 'income', icon: 'dollar-sign', color: '#6B7280' },
];

export const mockExpensesByCategory: ExpenseByCategory[] = [
    { category: 'Alimentação', amount: 1580, percentage: 25, color: '#F59E0B', icon: 'food' },
    { category: 'Moradia', amount: 1800, percentage: 28, color: '#047857', icon: 'home' },
    { category: 'Transporte', amount: 920, percentage: 15, color: '#059669', icon: 'car' },
    { category: 'Lazer', amount: 450, percentage: 7, color: '#0d9488', icon: 'entertainment' },
    { category: 'Contas', amount: 850, percentage: 13, color: '#EF4444', icon: 'bill' },
    { category: 'Saúde', amount: 420, percentage: 7, color: '#EC4899', icon: 'heart' },
    { category: 'Outros', amount: 300, percentage: 5, color: '#6B7280', icon: 'package' },
];

export const mockIncomeBySource: IncomeBySource[] = [
    { source: 'Salário', amount: 5500, percentage: 65, color: '#22C55E' },
    { source: 'Freelance', amount: 2500, percentage: 30, color: '#059669' },
    { source: 'Investimentos', amount: 450, percentage: 5, color: '#0d9488' },
];



// Mock de Movimentações do Fluxo de Caixa
export const mockCashFlowTransactions: CashFlowTransaction[] = [
    { id: '1', description: 'Venda de Produto A', amount: 1500.00, type: 'INCOME', category: 'Vendas', date: '2026-01-28T10:00:00', notes: 'Cliente João' },
    { id: '2', description: 'Pagamento Fornecedor', amount: 850.00, type: 'EXPENSE', category: 'Fornecedores', date: '2026-01-27T14:30:00' },
    { id: '3', description: 'Venda de Serviço', amount: 2500.00, type: 'INCOME', category: 'Serviços', date: '2026-01-26T09:15:00', notes: 'Consultoria' },
    { id: '4', description: 'Aluguel', amount: 3000.00, type: 'EXPENSE', category: 'Despesas Fixas', date: '2026-01-25T08:00:00' },
    { id: '5', description: 'Conta de Luz', amount: 450.00, type: 'EXPENSE', category: 'Despesas Fixas', date: '2026-01-24T11:00:00' },
    { id: '6', description: 'Venda Online', amount: 890.00, type: 'INCOME', category: 'Vendas', date: '2026-01-23T16:45:00', notes: 'E-commerce' },
    { id: '7', description: 'Material de Escritório', amount: 250.00, type: 'EXPENSE', category: 'Materiais', date: '2026-01-22T13:20:00' },
    { id: '8', description: 'Comissão Vendedor', amount: 600.00, type: 'EXPENSE', category: 'Pessoal', date: '2026-01-21T17:00:00', notes: 'Vendedor Carlos' },
    { id: '9', description: 'Venda de Produto B', amount: 3200.00, type: 'INCOME', category: 'Vendas', date: '2026-01-20T10:30:00' },
    { id: '10', description: 'Internet', amount: 200.00, type: 'EXPENSE', category: 'Despesas Fixas', date: '2026-01-19T09:00:00' },
    { id: '11', description: 'Projeto Especial', amount: 5000.00, type: 'INCOME', category: 'Serviços', date: '2026-01-18T14:00:00', notes: 'Cliente Maria' },
    { id: '12', description: 'Combustível', amount: 350.00, type: 'EXPENSE', category: 'Transporte', date: '2026-01-17T16:30:00' },
];

export const mockCashFlowSummary: CashFlowSummary = {
    totalIncome: 13090.00,
    totalExpense: 5700.00,
    balance: 7390.00,
};

export const mockFaqs: FAQ[] = [
    { id: '1', category: 'Conta', question: 'Como criar uma nova conta?', answer: 'Para criar uma nova conta, acesse o menu "Contas" no painel lateral e clique no botão "Nova Conta". Preencha as informações solicitadas como nome da conta, tipo (corrente, poupança, investimento), banco e saldo inicial. Após preencher, clique em "Salvar" para criar sua conta.', order: 1 },
    { id: '2', category: 'Conta', question: 'Posso ter múltiplas contas bancárias?', answer: 'Sim! Dependendo do seu plano, você pode cadastrar múltiplas contas bancárias. O plano Gratuito permite até 2 contas, o Básico até 5 contas, o Profissional até 15 contas e o Empresarial oferece contas ilimitadas.', order: 2 },
    { id: '3', category: 'Transações', question: 'Como registrar uma transação?', answer: 'Vá até o menu "Transações" e clique em "Nova Transação". Selecione o tipo (receita ou despesa), informe a descrição, valor, categoria, conta e data. Você também pode adicionar notas e tags para organizar melhor suas transações.', order: 1 },
    { id: '4', category: 'Transações', question: 'Posso editar uma transação já registrada?', answer: 'Sim, você pode editar qualquer transação. Na lista de transações, clique no ícone de edição (lápis) ao lado da transação que deseja modificar. Faça as alterações necessárias e clique em "Salvar".', order: 2 },
    { id: '5', category: 'Transações', question: 'Como categorizar minhas transações?', answer: 'O sistema oferece categorias pré-definidas como Alimentação, Transporte, Lazer, etc. Ao criar uma transação, selecione a categoria mais adequada. Nos planos Profissional e Empresarial, você pode criar categorias personalizadas em Configurações > Categorias.', order: 3 },
    { id: '6', category: 'Fluxo de Caixa', question: 'O que é o Fluxo de Caixa?', answer: 'O Fluxo de Caixa é uma ferramenta que mostra a movimentação de dinheiro (entradas e saídas) em um determinado período. Ele ajuda a visualizar sua situação financeira, identificar padrões de gastos e planejar melhor suas finanças.', order: 1 },
    { id: '7', category: 'Fluxo de Caixa', question: 'Como analisar meu fluxo de caixa?', answer: 'Acesse o menu "Fluxo de Caixa" para ver um resumo das suas entradas e saídas. Você pode filtrar por período (semana, mês, trimestre ou ano) e visualizar gráficos que mostram a evolução do seu saldo ao longo do tempo.', order: 2 },
    { id: '8', category: 'Relatórios', question: 'Quais relatórios estão disponíveis?', answer: 'Oferecemos diversos relatórios: Resumo Mensal, Despesas por Categoria, Evolução Patrimonial, Comparativo de Períodos, entre outros. Os relatórios podem ser exportados em PDF ou Excel nos planos que incluem essa funcionalidade.', order: 1 },
    { id: '9', category: 'Relatórios', question: 'Como exportar relatórios?', answer: 'Na página de Relatórios, selecione o relatório desejado e clique no botão "Exportar". Escolha o formato (PDF ou Excel) e o arquivo será baixado automaticamente. Esta funcionalidade está disponível a partir do plano Básico.', order: 2 },
    { id: '10', category: 'Planos e Pagamentos', question: 'Quais são os planos disponíveis?', answer: 'Oferecemos 4 planos: Gratuito (recursos básicos), Básico (R$ 19,90/mês), Profissional (R$ 49,90/mês) e Empresarial (R$ 99,90/mês). Cada plano oferece diferentes limites e funcionalidades. Consulte a página de planos para mais detalhes.', order: 1 },
    { id: '11', category: 'Planos e Pagamentos', question: 'Como alterar meu plano?', answer: 'Acesse Configurações > Meu Plano e clique em "Alterar Plano". Você pode fazer upgrade a qualquer momento. O valor será calculado proporcionalmente ao período restante do plano atual.', order: 2 },
    { id: '12', category: 'Planos e Pagamentos', question: 'Quais formas de pagamento são aceitas?', answer: 'Aceitamos cartão de crédito (Visa, Mastercard, Elo), boleto bancário e PIX. Para pagamentos recorrentes, recomendamos o cartão de crédito para evitar interrupções no serviço.', order: 3 },
    { id: '13', category: 'Segurança', question: 'Meus dados estão seguros?', answer: 'Sim! Utilizamos criptografia de ponta a ponta para proteger seus dados. Nossos servidores seguem os mais altos padrões de segurança da indústria. Nunca compartilhamos suas informações com terceiros sem sua autorização.', order: 1 },
    { id: '14', category: 'Segurança', question: 'Como alterar minha senha?', answer: 'Acesse Configurações > Segurança > Alterar Senha. Você precisará informar sua senha atual e a nova senha (duas vezes para confirmação). Recomendamos usar uma senha forte com letras, números e caracteres especiais.', order: 2 },
];

export const mockFaqCategories = ['Conta', 'Transações', 'Fluxo de Caixa', 'Relatórios', 'Planos e Pagamentos', 'Segurança'];

// Formas de Pagamento
export const mockPaymentMethods: PaymentMethod[] = [
    { id: '1', name: 'Dinheiro', description: 'Pagamento em espécie', isActive: true },
    { id: '2', name: 'PIX', description: 'Transferência instantânea', isActive: true },
    { id: '3', name: 'Cartão de Crédito', description: 'Visa, Mastercard, Elo', isActive: true },
    { id: '4', name: 'Cartão de Débito', description: 'Débito em conta', isActive: true },
    { id: '5', name: 'Boleto Bancário', description: 'Pagamento via boleto', isActive: true },
    { id: '6', name: 'Transferência Bancária', description: 'TED/DOC', isActive: true },
    { id: '7', name: 'Cheque', description: 'Pagamento com cheque', isActive: false },
];

// Plano de Contas (Hierárquico)
export const mockChartOfAccounts: ChartOfAccount[] = [
    { id: '1', code: '1', name: 'Receitas', type: 'REVENUE', level: 1, isActive: true },
    { id: '1.1', code: '1.1', name: 'Receita Operacional', type: 'REVENUE', parentId: '1', level: 2, isActive: true },
    { id: '1.1.1', code: '1.1.1', name: 'Venda de Produtos', type: 'REVENUE', parentId: '1.1', level: 3, isActive: true },
    { id: '1.1.2', code: '1.1.2', name: 'Prestação de Serviços', type: 'REVENUE', parentId: '1.1', level: 3, isActive: true },
    { id: '1.2', code: '1.2', name: 'Outras Receitas', type: 'REVENUE', parentId: '1', level: 2, isActive: true },
    { id: '1.2.1', code: '1.2.1', name: 'Rendimentos Financeiros', type: 'REVENUE', parentId: '1.2', level: 3, isActive: true },
    { id: '2', code: '2', name: 'Custos', type: 'COST', level: 1, isActive: true },
    { id: '2.1', code: '2.1', name: 'Custo das Mercadorias', type: 'COST', parentId: '2', level: 2, isActive: true },
    { id: '2.1.1', code: '2.1.1', name: 'Compra de Produtos', type: 'COST', parentId: '2.1', level: 3, isActive: true },
    { id: '2.1.2', code: '2.1.2', name: 'Frete de Compras', type: 'COST', parentId: '2.1', level: 3, isActive: true },
    { id: '3', code: '3', name: 'Despesas', type: 'EXPENSE', level: 1, isActive: true },
    { id: '3.1', code: '3.1', name: 'Despesas Operacionais', type: 'EXPENSE', parentId: '3', level: 2, isActive: true },
    { id: '3.1.1', code: '3.1.1', name: 'Salários e Encargos', type: 'EXPENSE', parentId: '3.1', level: 3, isActive: true },
    { id: '3.1.2', code: '3.1.2', name: 'Aluguel', type: 'EXPENSE', parentId: '3.1', level: 3, isActive: true },
    { id: '3.1.3', code: '3.1.3', name: 'Energia Elétrica', type: 'EXPENSE', parentId: '3.1', level: 3, isActive: true },
    { id: '3.1.4', code: '3.1.4', name: 'Água', type: 'EXPENSE', parentId: '3.1', level: 3, isActive: true },
    { id: '3.1.5', code: '3.1.5', name: 'Internet e Telefone', type: 'EXPENSE', parentId: '3.1', level: 3, isActive: true },
    { id: '3.2', code: '3.2', name: 'Despesas Comerciais', type: 'EXPENSE', parentId: '3', level: 2, isActive: true },
    { id: '3.2.1', code: '3.2.1', name: 'Comissões', type: 'EXPENSE', parentId: '3.2', level: 3, isActive: true },
    { id: '3.2.2', code: '3.2.2', name: 'Marketing', type: 'EXPENSE', parentId: '3.2', level: 3, isActive: true },
    { id: '3.3', code: '3.3', name: 'Despesas Financeiras', type: 'EXPENSE', parentId: '3', level: 2, isActive: true },
    { id: '3.3.1', code: '3.3.1', name: 'Juros e Multas', type: 'EXPENSE', parentId: '3.3', level: 3, isActive: true },
    { id: '3.3.2', code: '3.3.2', name: 'Taxas Bancárias', type: 'EXPENSE', parentId: '3.3', level: 3, isActive: true },
];
